import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material'
import { ColDef } from 'ag-grid-community'
import React, { useState } from 'react'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import { radiologyColor } from '../Radiology/Utils/RadiologyColors'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import { pageSizeOptions } from '../Radiology/Constants/constants'
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined'
// import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import CloseIcon from '@mui/icons-material/Close'
import CreateTable from './CreateTable'
import FinancialCounselingForm from './FinancialConsellingForm'

const styles = (theme: any) => ({
  centerHeader: {
    color: radiologyColor?.white,
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  actionBtn: {
    // color: '#183f7c',
  },
  createBtn: {
    backgroundColor: '#4682b4',
    textTransform: 'capitalize',
  },
  dialogCloseBtn: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
})

const Dashboard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // eslint-disable-next-line
  const [rowData, setRowData] = useState([
    {
      id: 1,
      firstName: 'John Doe',
      UHID: 'UH12345',
      phone: '123-456-7890',
      admissionDate: '2025-01-15',
      type: 'General',
      status: 'Accepted',
    },
    {
      id: 2,
      firstName: 'Jane Smith',
      UHID: 'UH67890',
      phone: '987-654-3210',
      admissionDate: '2025-01-20',
      type: 'Emergency',
      status: 'Rejected',
    },
    {
      id: 3,
      firstName: 'Michael Brown',
      UHID: 'UH11223',
      phone: '456-789-0123',
      admissionDate: '2025-01-10',
      type: 'General',
      status: 'OnHold',
    },
    {
      id: 4,
      firstName: 'Emily Davis',
      UHID: 'UH44556',
      phone: '321-654-0987',
      admissionDate: '2025-01-18',
      type: 'Emergency',
      status: 'Accepted',
    },
    {
      id: 5,
      firstName: 'Chris Wilson',
      UHID: 'UH77889',
      phone: '654-321-4567',
      admissionDate: '2025-01-12',
      type: 'General',
      status: 'Rejected',
    },
  ])

  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  // eslint-disable-next-line
  const [totalRows, setTotalRows] = useState(0)

  const [openCreate, setOpenCreate] = useState(false)
  const [openCounselling, setOpenCounselling] = useState(false)

  const handleClickOpenCounselling = () => {
    setOpenCounselling(true)
  }
  const handleCloseCounselling = () => {
    setOpenCounselling(false)
  }

  const handleClickOpenCreate = () => {
    setOpenCreate(true)
  }
  const handleCloseCreate = () => {
    setOpenCreate(false)
  }

  const renderName = (params: any) => {
    const firstName = params?.data?.firstName ?? ''
    const lastName = params?.data?.lastName ?? ''
    return firstName.concat(' ', lastName)
  }

  // eslint-disable-next-line
  const renderComments = (params: any) => {
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
      >
        <IconButton size='small' className={classes?.actionBtn}>
          <AssignmentOutlinedIcon />
        </IconButton>
      </Box>
    )
  }
  // eslint-disable-next-line
  const renderActions = (params: any) => {
    return (
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        width={'100%'}
      >
        <Tooltip
          title={'Financial Conselling'}
          placement='top-start'
          arrow
          onClick={handleClickOpenCounselling}
        >
          <IconButton size='small' className={classes?.actionBtn}>
            <RequestQuoteOutlinedIcon />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title={'Transfer to IPD'} placement='top-start' arrow>
          <IconButton size='small' className={classes?.actionBtn}>
            <MoveUpOutlinedIcon />
          </IconButton>
        </Tooltip> */}
      </Box>
    )
  }

  const FilterActions = () => {
    return (
      <Button
        variant='contained'
        size='small'
        className={classes?.createBtn}
        onClick={handleClickOpenCreate}
      >
        Create
      </Button>
    )
  }

  const columnDefs: ColDef[] = [
    {
      headerName: 'Sl No',
      field: 'id',
      width: 90,
      sortable: true,
      filter: false,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Name',
      field: 'firstName',
      flex: 1,
      sortable: true,
      filter: true,
      cellRenderer: renderName,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      minWidth: 165,
    },
    {
      headerName: 'UHID',
      field: 'UHID',
      flex: 1,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', display: 'flex', alignItems: 'center' },
      minWidth: 110,
    },
    {
      headerName: 'Phone',
      field: 'phone',
      flex: 1,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 145,
    },
    {
      headerName: 'Admission Date(Tentative)',
      field: 'admissionDate',
      flex: 1,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 140,
    },
    {
      headerName: 'Type',
      field: 'type',
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 130,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      flex: 1,
      sortable: true,
      filter: true,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      minWidth: 110,
    },
    {
      headerName: 'Comments',
      field: 'comments',
      sortable: false,
      filter: false,
      cellRenderer: renderComments,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px' },
      width: 100,
    },

    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,
      sortable: false,
      filter: false,
      cellRenderer: renderActions,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center', display: 'flex' },
    },
  ]

  return (
    <Box height={'89%'} width={'100%'} pl={2} pr={2} pt={1}>
      <Dialog
        onClose={handleCloseCounselling}
        aria-labelledby='customized-dialog-title-create'
        open={openCounselling}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title-create'>
          Financial Counseling
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleCloseCounselling}
          className={classes?.dialogCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <FinancialCounselingForm />
        </DialogContent>
      </Dialog>
      <Dialog
        onClose={handleCloseCreate}
        aria-labelledby='customized-dialog-title-create'
        open={openCreate}
        maxWidth='xl'
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title-create'>
          Create
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleCloseCreate}
          className={classes?.dialogCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <CreateTable />
        </DialogContent>
      </Dialog>
      <MedAgDataGrid
        tableHeading='Financial Counselling'
        tableHeight={'100%'}
        rowData={rowData}
        columnDefs={columnDefs}
        pagination={true}
        pageSizeOptions={pageSizeOptions}
        totalRows={totalRows}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        headerHeight={30}
        searchFieldWidth={200}
        loading={false}
        filterActions={<FilterActions />}
      />
    </Box>
  )
}

export default Dashboard
